<style lang="scss" scoped="scoped">
::-webkit-scrollbar {
  display: none;
}
</style>
<style lang="scss"></style>
<template>
  <div style="display: flex;width: 100%;height: 473px;">
    <el-tabs tab-position="left">
      <el-tab-pane :label="$t('xianshimoban')" style="padding: 0px 56px;">
        <div v-if="false" class="titleBar" style="display: flex;align-items:center ;">
          <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
          <p style="font-size: 16px;line-height: 22px;color: #303133;">
            {{ $t("shifouxianshi") }}
          </p>
        </div>
        <div>
          <el-radio v-model="monitorSetting.MACHINE_MODEL_TEMPLATE" label="moren">{{ $t("moren") }}</el-radio>
          <el-radio v-model="monitorSetting.MACHINE_MODEL_TEMPLATE" label="shebeiweixiu">{{ $t("zhixianshishebeiweixiu") }}</el-radio>
          <el-radio v-model="monitorSetting.MACHINE_MODEL_TEMPLATE" label="mojuweixiu">{{ $t("zhixianshimojuweixiu") }}</el-radio>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('yansheshezhi')" style="padding: 0px 56px;">
        <div>
          <el-radio v-model="monitorSetting.MONITOR_MANUFACTURING_TEMPLATE" label="black">{{ $t("heise") }}</el-radio>
          <el-radio v-model="monitorSetting.MONITOR_MANUFACTURING_TEMPLATE" label="blue">{{ $t("lanse") }}</el-radio>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "web_monitor_machine_model_setting",
  components: {},

  data() {
    return {
      monitorSetting: {},
    };
  },
  created() {
    this.resetData();
  },
  activated() {
    this.resize();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },
  destroyed() { },
  methods: {
    resetData() {
      //可能要防到mainjs里面去初始化,因为看板拿配置的时候setting弹框还没打开
      let monitorSetting = localStorage.getItem("MONITOR_SETTING");
      if (!monitorSetting) {
        this.monitorSetting = {};
      } else {
        this.monitorSetting = JSON.parse(monitorSetting);
      }
      this.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE = this.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE != null ? this.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE : "black";
      localStorage.setItem("MONITOR_SETTING", JSON.stringify(this.monitorSetting));
      //每个单独初始化可以进行增量初始化，而不是一整个setting初始化
      this.monitorSetting.MACHINE_MODEL_TEMPLATE = this.monitorSetting.MACHINE_MODEL_TEMPLATE != null ? this.monitorSetting.MACHINE_MODEL_TEMPLATE : "moren";

      //   this.monitorSetting.MONITOR_WORKSHOP_CARD_FONT = this.monitorSetting.MONITOR_WORKSHOP_CARD_FONT != null ? this.monitorSetting.MONITOR_WORKSHOP_CARD_FONT : 14;

      this.monitorSetting.MACHINE_MODEL_TEMPLATES = {
        moren: [
          {
            x: 0,
            y: 0,
            w: 12,
            h: 4, //应该是6
            i: "machine_count",
          },

          {
            x: 0,
            y: 2,
            w: 12,
            h: 10, //应该是6
            i: "machine_wait",
          },
          {
            x: 0,
            y: 12,
            w: 12,
            h: 10, //应该是6
            i: "machine_repairing",
          },
          {
            x: 12,
            y: 0,
            w: 12,
            h: 4, //应该是6
            i: "mold_count",
          },
          {
            x: 12,
            y: 2,
            w: 12,
            h: 10, //应该是6
            i: "mold_wait",
          },
          {
            x: 12,
            y: 14,
            w: 12,
            h: 10, //应该是6
            i: "mold_repairing",
          },
        ],
        shebeiweixiu: [
          {
            x: 0,
            y: 0,
            w: 24,
            h: 4, //应该是6
            i: "machine_count",
          },

          {
            x: 0,
            y: 2,
            w: 24,
            h: 10, //应该是6
            i: "machine_wait",
          },
          {
            x: 0,
            y: 12,
            w: 24,
            h: 10, //应该是6
            i: "machine_repairing",
          },
        ],
        mojuweixiu: [
          {
            x: 12,
            y: 0,
            w: 24,
            h: 4, //应该是6
            i: "mold_count",
          },
          {
            x: 12,
            y: 2,
            w: 24,
            h: 10, //应该是6
            i: "mold_wait",
          },
          {
            x: 12,
            y: 14,
            w: 24,
            h: 10, //应该是6
            i: "mold_repairing",
          },
        ],
      };
      localStorage.setItem("MONITOR_SETTING", JSON.stringify(this.monitorSetting));
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => { }, 500);
    },
    save() {
      localStorage.setItem("MONITOR_SETTING", JSON.stringify(this.monitorSetting));
      this.utils.event_hub.$emit("SetMachineModelLayout");
    },
  },
};
</script>
